import React, { useState } from 'react';
import { Query, useMutation } from 'react-apollo';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import PersonIcon from '@material-ui/icons/Person';
import { blue } from '@material-ui/core/colors';
import Checkbox from '@material-ui/core/Checkbox';
import Spin from 'components/common/Spin';
import Button from 'components/common/Button';
import { GET_CONVO_COACHES } from 'graphql/conversations';
import { INSERT_NOTIFICATION } from 'graphql/notification';
import { getFullName } from 'utils';
import { USER_TYPES } from 'constant/userTypes';
import useSnack from "hooks/useSnack";

const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
});

function NotifyModal({ message, onClose, user }) {
  const classes = useStyles();
  const [selected, onSelect] = useState({});
  const [insert] = useMutation(INSERT_NOTIFICATION);
  const snack = useSnack();

  const handleClose = () => {
    onClose();
  };


  const handleToggle = (user) => () => {
    const hasSelected = selected[user.user_id];

    if (hasSelected) {
      delete selected[user.user_id];
    } else {
      selected[user.user_id] = true;
    }
    onSelect({
      ...selected,
    });
  };

  const handleSubmit = async () => {
    const values = Object.keys(selected);
    try {
      await insert({
        variables: {
          data: values.map(id => ({
            "actor_id": user.id,
            "data": { convo_id: message.convo_id, message: message.text },
            "message": `Admin wants you to review message from ${message.user.user_first_name}`,
            "recipient_id": id,
            "subject": "messages",
            "subject_id": message.id,
            "topic": "CONVO_ADMIN_REMINDER"
          }))
        }
      });
      snack.success('Notification sent');
      onClose();
    } catch (e) {
      snack.error(e.message);
    }
  };
  const hasValues = Object.keys(selected).find((i) => i);

  return (
    <Dialog onClose={handleClose} open>
      <DialogTitle>Select Recipients</DialogTitle>
      <Query
        query={GET_CONVO_COACHES}
        variables={{ id: message.convo_id }}
        fetchPolicy="cache-first"
      >
        {({ data, loading }) => {
          if (loading) return <Spin spinning />;
          const {convo } = data;
          const rows = [];

          if (convo.group) {
            const { lc, hc } = convo.group;
            if (hc) rows.push(hc);
            if (lc) rows.push(lc);
          } else if (convo.student) {
            const { student_profiles } = convo.student;
            if (student_profiles[0].lc_user) rows.push(student_profiles[0].lc_user);
            if (student_profiles[0].hc_user) rows.push(student_profiles[0].hc_user);
          }

          return (
            <Spin spinning={loading}>
              <div>
                <List>
                  {rows.map((user) => (
                    <ListItem key={user.user_id}>
                      <ListItemAvatar>
                        <Avatar src={user.avatar} className={classes.avatar}>
                          <PersonIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={getFullName(user)}
                        secondary={USER_TYPES[user.user_type]}
                      />
                      <ListItemSecondaryAction>
                        <Checkbox
                          disableRipple
                          edge="end"
                          onChange={handleToggle(user)}
                          checked={selected[user.user_id]}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
                <Button
                  fullWidth
                  disabled={!hasValues}
                  size="large"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Send
                </Button>
              </div>
            </Spin>
          );
        }}
      </Query>
    </Dialog>
  );
}

export default NotifyModal;
